var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-307": "true",
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 6.673c0-1.041.352-1.824.874-2.345C7.398 3.805 8.139 3.5 9 3.5c.86 0 1.602.305 2.126.828.522.521.874 1.304.874 2.345a3.894 3.894 0 0 1-1.05 2.646c-.629.678-1.38 1.014-1.95 1.014-.57 0-1.321-.336-1.95-1.014A3.894 3.894 0 0 1 6 6.673ZM9 2c-1.222 0-2.356.438-3.186 1.267C4.98 4.1 4.5 5.277 4.5 6.673a5.394 5.394 0 0 0 1.951 4.14 9.891 9.891 0 0 0-1.873.658c-1.464.693-2.811 1.828-3.448 3.557-.3.811-.067 1.59.423 2.132.475.526 1.193.84 1.947.84h8.75a.75.75 0 0 0 0-1.5H3.5c-.35 0-.657-.15-.834-.346-.163-.18-.212-.382-.129-.607.463-1.256 1.459-2.14 2.683-2.72C6.449 12.246 7.853 12 9 12c.907 0 1.981.154 3.004.51a.75.75 0 0 0 .494-1.416c-.315-.11-.632-.203-.95-.28a5.394 5.394 0 0 0 1.951-4.14c.001-1.397-.48-2.575-1.313-3.407C11.356 2.438 10.223 2 9 2Zm6.5 9a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.0611059f7544beae2a77ddfd343a90ac.svg";
export { ForwardRef as ReactComponent };